import type { ReactNode } from 'react';

import { getAppletsUrl } from '@cartwhl/common/utils';
import GoButton from '@cartwhl/ui/input/GoButton';

interface MotionEditorCTAProps {
  children?: ReactNode;
}

export default function MotionEditorCTA({
  children = 'Try Motion Editor',
}: MotionEditorCTAProps) {
  return (
    <p className="mb-8">
      <a
        href={`${getAppletsUrl()}/motion-editor`}
        target="_blank"
        rel="noopener noreferrer"
        className="no-underline hover:no-underline"
      >
        <GoButton variant="animate" className="px-10">
          {children}
        </GoButton>
      </a>
    </p>
  );
}
